<template>
  <div class="trialreminder-container">
    <div class="banner">
      Your trial ends in {{ daysLeft }} days <span class="upgrade" @click="gotoPlans()">Upgrade now</span>
    </div>
  </div>
</template>

<script>
import moment from 'moment'


export default {
  name: 'TrialReminder',
  data() {
    return {
      showBanner: true,
      daysLeft: null,
    }
  },
  mounted() {
    let now = moment()
    let validUntil = moment(this.subscription.validUntil)
    this.daysLeft = validUntil.diff(now, 'days')
  },
  methods: {
    gotoPlans() {
      this.$router.push('/subscription/plans')
    }
  },
  computed: {
    subscription() {
      return this.$store.getters.subscription
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.trialreminder-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;

  .banner {
    background-color: $primary;
    padding: 10px;
    color: white;
  }

  .upgrade {
    border-radius: $border-radius;
    border: 1px solid white;
    padding: 3px 8px;
    margin-left: 20px;
    cursor: pointer;
    transition: 0.2s all;

    &:hover {
      background-color: white;
      color: $primary;
    }
  }
}
</style>